import { NgClass } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { take } from 'rxjs';
import { CignaIconComponent } from '../../../shared/components/cigna-icon/cigna-icon.component';
import { StorageKeys } from '../../../shared/enums/storage-keys.enum';
import { ModalContactoComponent } from '../../../shared/modals/modal-contacto/modal-contacto.component';
import { InsuredData } from '../../../shared/models/user-data';
import { ApiService } from '../../../shared/services/api.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { ModalService } from '../../../shared/services/modal.service';
import { StorageService } from '../../../shared/services/storage.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { IosChatTransitionService } from '../../services/ios-chat-transition.service';
import { SalesforceChatService } from '../../services/salesforce-chat.service';

@Component({
  selector: 'app-floating-chat',
  templateUrl: './floating-chat.component.html',
  standalone: true,
  imports: [CignaIconComponent, ButtonModule, TranslateModule, NgClass],
})
export class FloatingChatComponent implements OnInit {
  private _apiService = inject(ApiService);
  private _iosChatTransition = inject(IosChatTransitionService);
  private _loadingService = inject(LoadingService);
  private _modalService = inject(ModalService);
  private _salesforceChatService = inject(SalesforceChatService);
  private _storageService = inject(StorageService);
  private _utilsService = inject(UtilsService);

  floatingVisible: boolean = false;
  isMobile: boolean = this._utilsService.isMobile();

  ngOnInit(): void {
    this._apiService
      .getProperty('customerportal.salesforce.chat.active')
      .pipe(take(1))
      .subscribe(prop => {
        this.floatingVisible = prop.value === 'true';
        this._salesforceChatService.loadNewChat(this);
      });
  }

  openChat(): void {
    const logData: InsuredData = this._storageService.sessionStorageGetItem(
      StorageKeys.LOGIN_DATA
    );
    this._storageService.sessionStorageSetItem(StorageKeys.CHAT_USER, logData);

    // iOS only: cover the UI immediately (DOM overlay + held loader) before any HTTP.
    const iosHttpsChat = this._salesforceChatService.shouldOpenChatInHttpsWebView();
    if (iosHttpsChat) {
      this.floatingVisible = false;
      this._iosChatTransition.show();
      this._loadingService.holdLoader();
    }

    this._apiService
      .getProperty('chat.bank.holiday')
      .pipe(take(1))
      .subscribe({
        next: prop => {
          const time = new Date();
          let onTime: boolean = false;
          //Lun-Vier
          if (time.getDay() < 6) {
            //8-20
            if (time.getHours() >= 8 && time.getHours() < 20) {
              onTime = true;
            }
          }
          if (prop?.value) {
            if (prop.value.includes(this._utilsService.dateToDate(time))) {
              onTime = false;
            }
          }
          if (onTime) {
            this.floatingVisible = false;
            this._salesforceChatService.openChat(this);
          } else {
            if (iosHttpsChat) {
              this._iosChatTransition.hide();
              this._loadingService.releaseLoader();
              this.floatingVisible = true;
            }
            this._modalService.showModal(ModalContactoComponent, {}, '24rem');
          }
        },
        error: () => {
          if (iosHttpsChat) {
            this._iosChatTransition.hide();
            this._loadingService.releaseLoader();
            this.floatingVisible = true;
          }
        },
      });
  }

  showButton(): void {
    this.floatingVisible = true;
  }
  hideButton(): void {
    this.floatingVisible = false;
  }
}
